module.exports = __webpack_public_path__ + "static/patient-michael-profile-img-ed64165af8382b85d4e691e75c4dd265.png";